module.exports = __webpack_public_path__ + "static/webhooks-9b76a6f0d68b8a342244b89588b85e16.svg";